var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.5483 41.4909C41.962 44.0735 37.7593 44.0734 35.1731 41.4581L14.2242 20.0782C11.6703 17.4629 11.6703 13.2131 14.2566 10.5978C16.8429 8.01519 21.0455 8.01522 23.6318 10.6305L44.5806 32.0104C47.1346 34.6257 47.1346 38.9083 44.5483 41.4909Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2892 10.5977L5.85152 2",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1064 38.9033L42.0337 43.991L47.4519 49.5151L52.5246 44.4274L47.1064 38.9033Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2847 51.403C57.4412 48.2372 59.0317 44.6836 57.8373 43.4658C56.6428 42.248 53.1157 43.8272 49.9592 46.993C46.8027 50.1588 45.2122 53.7125 46.4066 54.9303C47.6011 56.1481 51.1282 54.5689 54.2847 51.403Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0094 40.2484L36.2077 38.0581",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1036 24.0338L20.3019 21.8108",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4746 31.5526L27.6729 29.3296",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7419 35.9004L34.8822 30.7679",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7891 27.7931L26.9293 22.6279",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4333 20.5683C7.62945 20.5683 8.56698 19.5875 8.56698 18.378C8.56698 17.953 8.46997 17.6261 8.34066 17.2665L8.47 17.7242C8.43767 17.5607 8.37305 17.3973 8.3084 17.1684C8.3084 17.1684 6.75658 13.0493 6.33631 13.0493C5.91605 13.0493 4.46131 17.2338 4.46131 17.2338C4.36433 17.5934 4.26735 17.953 4.26735 18.378C4.26735 19.5875 5.23715 20.5683 6.4333 20.5683C6.85356 20.5683 7.27382 20.4375 7.62943 20.2087L6.4333 20.5683Z",
    fill: "#48CAE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16595 13.8992C3.32977 13.8992 4.29963 12.9185 4.29963 11.6762C4.29963 11.2512 4.20262 10.9244 4.07331 10.5321L4.20265 10.9897C4.17032 10.8263 4.10571 10.6302 4.04105 10.434C4.04105 10.434 2.48923 6.28223 2.06897 6.28223C1.6487 6.28223 0.193962 10.5321 0.193962 10.5321C0.0969773 10.9244 0 11.2512 0 11.6762C0.0323284 12.8858 0.969796 13.8992 2.16595 13.8992C2.58622 13.8992 3.00654 13.7685 3.32982 13.5396L2.16595 13.8992Z",
    fill: "#48CAE4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory2);
export default __webpack_public_path__ + "static/media/category2.2be28bf932c5a373e6e8e587fb615f4d.svg";
export { ForwardRef as ReactComponent };